"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.OffersStep = void 0;
var _checkoutOffers = require("@ori/checkout-offers");
var _jsxRuntime = require("react/jsx-runtime");
const OffersStep = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutOffers.CheckoutOffers, {});
exports.OffersStep = OffersStep;
var _default = exports.default = OffersStep;
